module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAALRJREFUKBVjdE9M+89ABPj/n6Fh14JZjW4Jqf8YgeA/EDARoQ+mhBHEAGmE0SDNP0EcQuA/w/9PIDVAC79C1b4hpGeQyjO6J6Tu/8/IAA4E/G5knL9r/qyFbolp+4A+B4YV4z8WYPA5EKETGFAMB0CGA9U6gkkgm5SoIio9gCwY5IDRPTEVmHIYeQm68///ip0LZncC88JroFoRYAB8AQU5YY1A1f8ZGDmhFoiAaGCo81AU2gC28DEw9/o4UwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-union.png
// module id = 2020
// module chunks = 0